import { useEffect, useRef } from "react";

/**
 * Hält den per Tastatur markierten Vorschlag einer Auswahlliste sichtbar
 * (T-50). jsdom kennt `scrollIntoView` nicht — deshalb die Abfrage.
 */
export function useAktivSichtbar(aktiv: number, anzahl: number) {
    const ref = useRef<HTMLButtonElement | null>(null);
    useEffect(() => {
        const el = ref.current;
        if (el && typeof el.scrollIntoView === "function") el.scrollIntoView({ block: "nearest" });
    }, [aktiv, anzahl]);
    return ref;
}
